// hooks/useProfesorFormatos.ts
import { useCallback, useEffect, useMemo, useState } from 'react';
import api from '../api/axios';

const BIT_P = 1; // presencial
const BIT_O = 2; // online
const BIT_D = 4; // a domicilio

export interface ProfesorFormatoRow {
  idUsuario: number;
  idFormato: number;            // 1=Online, 2=Presencial, 3=A Domicilio, 4=Todos
  formato?: { id: number; nombre: string };
}

export function useProfesorFormatos(idProfesor: number | null | undefined) {
  const [rows, setRows] = useState<ProfesorFormatoRow[]>([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!idProfesor) { setRows([]); return []; }
    setLoading(true);
    try {
      const { data } = await api.get<ProfesorFormatoRow[]>(`/profesores/${idProfesor}/formatos`);
      setRows(Array.isArray(data) ? data : []);
      return Array.isArray(data) ? data : [];
    } finally {
      setLoading(false);
    }
  }, [idProfesor]);

  useEffect(() => { void refresh(); }, [refresh]);

  const assignedMask = useMemo(() => {
    let m = 0;
    for (const r of rows) {
      const id = r?.idFormato ?? r?.formato?.id;
      if (id === 4) { m |= BIT_P | BIT_O | BIT_D; continue; }
      if (id === 2) m |= BIT_P;   // Presencial
      else if (id === 1) m |= BIT_O; // Online
      else if (id === 3) m |= BIT_D; // A Domicilio
    }
    return m; // 0 => sin registros (modo compatibilidad en backend)
  }, [rows]);

  return { rows, loading, assignedMask, refresh };
}
